import {observable, action} from 'mobx';

class EnvStore{
    // 监控数据
    @observable.shallow devices = [];

    @action setDevices(devices) {
        this.devices = devices;
    }
    
    @observable.shallow info = [];

    @action setInfo(info) {
        this.info = info;
    }
}

export default new EnvStore();